const PREFIX = "Shared/Employee/";

export const RECEIVE_EMPLOYEES = `${PREFIX}RECEIVE_EMPLOYEES`;

export const RECEIVE_EMPLOYEE = `${PREFIX}RECEIVE_EMPLOYEE`;

export const UPDATE_EMPLOYEE = `${PREFIX}UPDATE_EMPLOYEE`;
